import { beads } from '../beads.js';
import { settings } from '../settings.js';
import { save } from '../projects/save.js';

const trimPeyote = () => {

    // assign peyote row and column numbers to every bead

    const getPeyoteCoordinates = bead => {
        let result = {};

        let addRow = (beads.rowOffset[bead.row]) ? 0 : 1;
        [result.row, result.column] = [bead.column, settings.rows - bead.row - 1];
        result.row = (result.row * 2) + addRow;

        return result;
    };

    // find max and min

    let myColumn = {max: null, min: null};
    let myRow = {max: null, min: null};
    let haveBeads = false;

    beads.arr.forEach(bead => {
        bead.temp = getPeyoteCoordinates(bead);
        if (bead.style !== null) {
            if (!myColumn.max) {
                myColumn.max = bead.temp.column;
                myColumn.min = bead.temp.column;
                myRow.max = bead.temp.row;
                myRow.min = bead.temp.row;
            }
            myColumn.max = Math.max(bead.temp.column, myColumn.max);
            myColumn.min = Math.min(bead.temp.column, myColumn.min);
            myRow.max = Math.max(bead.temp.row, myRow.max);
            myRow.min = Math.min(bead.temp.row, myRow.min);
            haveBeads = true;
        }
    });

    if (!haveBeads) return;

    // create new co-ordinate system so pattern is smooshed up to top left

    beads.arr.forEach(bead => {
        bead.temp.row -= myRow.min;
        bead.temp.column -= myColumn.min;
    });

    // now work out new rows and columns

    beads.arr.forEach(bead => {
        if (bead.temp.row % 2 == 0) {
            bead.column = bead.temp.row / 2;
        } else {
            bead.column = (bead.temp.row - 1) / 2;
        }

        bead.row = (myColumn.max - myColumn.min) - bead.temp.column;
    });

    // deal with offset pattern

    // if top bead is a down bead, swap the offset pattern

    let newOffset = [];
    if (myRow.min % 2 == 1) {
        beads.rowOffset.forEach(r => {
            if (r == 0) newOffset.push(1);
            else newOffset.push(0);
        });
    } else {
        newOffset = beads.rowOffset;
    }

    // now create slice of offset pattern

    newOffset.reverse();
    newOffset = newOffset.slice(myColumn.min, myColumn.max + 1);
    newOffset.reverse();

    beads.rowOffset = newOffset;

    const temp = (myRow.max - myRow.min) + 1;

    settings.columns = (temp % 2 === 0) ? temp / 2 : (temp + 1) / 2;
    settings.rows = (myColumn.max - myColumn.min + 1);
    settings.ignoreLastRow = temp % 2 === 0;

    game.cameras.main.setScroll(-100, -100);

    save.currentlyOpenFile({reload: true});
};

// work out how many empty rows and columns above the project

const calculateEmptySpace = ({beadArray}) => {

    const activeBeads = beadArray.filter(bead => typeof bead.style === 'number');
    if (!activeBeads.length) return {emptyColumns: 0, emptyRows: 0};

    const emptyColumns = activeBeads[0].column;
    const emptyRows = Math.min(...activeBeads.map(bead => bead.row));

    return {emptyColumns, emptyRows};
};

const calculateEmptySpaceBelow = ({beadArray}) => {

    const activeBeads = beadArray.filter(bead => typeof bead.style === 'number');
    if (!activeBeads.length) return {emptyColumnsBelow: 0, emptyRowsBelow: 0};

    let emptyColumnsBelow, emptyRowsBelow;

    for (let i = beadArray.length - 1; i >= 0; i--) {
        if (typeof beadArray[i].style === 'number') {
            emptyColumnsBelow = settings.columns - beadArray[i].column - 1;
            break;
        }
    }

    for (let i = settings.rows - 1, found = false; i >= 0 && !found; i--) {
        for (let j = settings.columns - 1; j >= 0 && !found; j--) {
            const myBead = beadArray.find(element => (element.row === i) && (element.column === j));
            if (typeof myBead.style === 'number') {
                emptyRowsBelow = settings.rows - myBead.row - 1;
                found = true;
            }
        }
    }

    return {emptyColumnsBelow, emptyRowsBelow};
};

export const trim = () => {

    // Trim peyote uses a different function

    if (settings.pattern.rotateCamera) {
        trimPeyote();
        return;
    }

    const {emptyColumns, emptyRows} = calculateEmptySpace({beadArray: beads.arr});
    const {emptyColumnsBelow, emptyRowsBelow} = calculateEmptySpaceBelow({beadArray: beads.arr});

    if (
        [emptyColumns, emptyRows, emptyColumnsBelow, emptyRowsBelow].every(element => element === 0)
    ) {
        return;
    }

    // translate the project

    beads.arr.forEach(bead => {
        const myBead = beads.arr.find(element =>
            (element.row === bead.row + emptyRows) &&
            (element.column === bead.column + emptyColumns)
        );

        bead.style = myBead?.style ?? null;
        bead.active = myBead?.active || false;
    });

    // translate the row offset pattern

    if (settings.rows - emptyRows < beads.rowOffset.length) {
        beads.rowOffset = beads.rowOffset.slice(0, settings.rows - emptyRows);
    }

    let newOffset = [];

    for (let i = 0; i < settings.rows; i++) {
        if (beads.rowOffset[i + emptyRows] !== undefined) {
            newOffset.push(beads.rowOffset[i + emptyRows]);
        }
    }

    beads.rowOffset = newOffset;

    game.cameras.main.setScroll(0, 0);

    beads.refreshCanvas();

    // work out how many empty rows and colums below the project

    const remainingSpace = calculateEmptySpaceBelow({beadArray: beads.arr});

    // delete all the empty rows and colums starting at the end of the project

    settings.rows = settings.rows - remainingSpace.emptyRowsBelow;
    settings.columns = settings.columns - remainingSpace.emptyColumnsBelow;

    save.currentlyOpenFile({reload: true});
};
